import { createTheme } from '@mui/material/styles';

const sharedComponents = {
  MuiTypography: {
    styleOverrides: {
      root: {
        '&.MuiTypography-gutterBottom': {
          marginBottom: '2rem',
        },
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        padding: '8px 20px',
      },
      contained: {
        boxShadow: '0 2px 8px rgba(13, 59, 94, 0.25)',
        '&:hover': {
          boxShadow: '0 4px 16px rgba(13, 59, 94, 0.35)',
        },
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
        },
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        boxShadow: '0 1px 12px rgba(0, 0, 0, 0.08)',
      },
    },
  },
};

const sharedTypography = {
  fontFamily: '"Inter", "Segoe UI", Roboto, sans-serif',
  h2: { fontWeight: 700, letterSpacing: '-0.02em' },
  h4: { fontWeight: 700, letterSpacing: '-0.01em' },
  h5: { fontWeight: 600 },
  h6: { fontWeight: 600 },
  body1: { lineHeight: 1.7 },
  body2: { lineHeight: 1.6 },
};

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0d3b5e',
      light: '#1a608e',
      dark: '#092a44',
    },
    secondary: {
      main: '#1a608e',
      light: '#2980b9',
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
    text: {
      primary: '#1a1a2e',
      secondary: '#555770',
    },
  },
  typography: sharedTypography,
  shape: { borderRadius: 12 },
  components: {
    ...sharedComponents,
    MuiCard: {
      styleOverrides: {
        root: {
          ...sharedComponents.MuiCard.styleOverrides.root,
          boxShadow: '0 2px 16px rgba(0, 0, 0, 0.06)',
          '&:hover': {
            ...sharedComponents.MuiCard.styleOverrides.root['&:hover'],
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          },
        },
      },
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1a608e',
      light: '#2980b9',
      dark: '#0d3b5e',
    },
    secondary: {
      main: '#2980b9',
      light: '#5dade2',
    },
    background: {
      default: '#0f1724',
      paper: '#1a2332',
    },
    text: {
      primary: '#e8eaf0',
      secondary: '#9ba4b5',
    },
    divider: 'rgba(255,255,255,0.08)',
  },
  typography: sharedTypography,
  shape: { borderRadius: 12 },
  components: {
    ...sharedComponents,
    MuiCard: {
      styleOverrides: {
        root: {
          ...sharedComponents.MuiCard.styleOverrides.root,
          boxShadow: '0 2px 16px rgba(0, 0, 0, 0.3)',
          border: '1px solid rgba(255,255,255,0.06)',
          '&:hover': {
            ...sharedComponents.MuiCard.styleOverrides.root['&:hover'],
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
          },
        },
      },
    },
  },
});

// Default export for backwards compat
export default lightTheme;
